import './addCourseInformation.scss'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import useScreenSize from '../../hooks/useScreenSize'
import Button from '../../components/button/Button'
import Chips from '../../components/chips/Chips'
import NewInput from '../../components/input/NewInput'
import { useNavigate, useParams } from 'react-router-dom'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { useCallback, useEffect, useState } from 'react'
import {  handleInputStringWithNum, handlePassword } from '../../utility/genricFunction'
import { useDispatch, useSelector } from 'react-redux'
import {
  createCourseInformation,
  editCourseInformation,
  getCourseByCourseId,
  getCourseMaterials,
} from '../../store/builders/course/course.builder'
import { setCourseInformation } from '../../store/slice/course/course.slice'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'
import Loader from '../../components/loader/Loader'

function AddCourseInformation() {
  const screenSize = useScreenSize()
  const navigate = useNavigate()
  const { id } = useParams()
  const { materials, courseInformation, courseId, course, currentCourse, loading } = useSelector((store) => {
    return store.course
  })
  const dispatch = useDispatch()

  const fetchCourseInfo = useCallback(() => {
    if (id) {
      dispatch(getCourseByCourseId(id))
    }
  }, [dispatch, id])

  useEffect(() => {
    fetchCourseInfo()
  }, [fetchCourseInfo])

  useEffect(() => {
    dispatch(getCourseMaterials())
  }, [dispatch])

  const [initialValues, setInitialValues] = useState({
    courseName: '',
    aliasName: '',
    checked: [],
    materialId: [],
  })

  const AddCourseSchema = Yup.object().shape({
    courseName: Yup.string().required(VALIDATION_MESSAGES.COURSE_REQUIRED),
    aliasName: Yup.string().required(VALIDATION_MESSAGES.ALIAS),
    checked: Yup.array().min(1, 'At least one option must be selected').required('Required'),
    materialId: Yup.array().min(1, 'At least one chip is required').required('Required'),
    // chips: Yup.array().min(1, 'At least one chip is required').required('Required'),
  })

  const breadCrumbsArr = [
    {
      title: id ? UI_CONSTANT.COURSE.EDIT_COURSE : UI_CONSTANT.COURSE.ADD_COURSE,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.COURSE.LABLE_COURSE,
      link: ROUTES_PATH.COURSE,
    },
    {
      title: id ? UI_CONSTANT.COURSE.EDIT_COURSE_INFORMATION : UI_CONSTANT.COURSE.COURSE_INFORMATION,
      link: id ? ROUTES_PATH.EDIT_COURSE_INFORMATION.replace(':id', id) : ROUTES_PATH.ADD_COURSE_INFORMATION,
    },
  ]

  useEffect(() => {
    if (courseInformation && !id) {
      setInitialValues(courseInformation)
    }
    if (!courseId) {
      setInitialValues({
        courseName: '',
        aliasName: '',
        checked: [],
        materialId: [],
      })
    }
    if (id && Object.keys(currentCourse).length) {
      const values = {
        courseName: currentCourse.courseName,
        aliasName: currentCourse.courseAliasName,
        checked: JSON.parse(currentCourse.examFormat),
        materialId: currentCourse.course_materials.map((material) => material.material_id),
      }
      setInitialValues(values)
    }
  }, [course, courseId, courseInformation, currentCourse, id])

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> && <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={AddCourseSchema}
      onSubmit={(values) => {
        dispatch(setCourseInformation(values))
        if (courseId && !id) {
          dispatch(editCourseInformation({ courseId, ...values, hasId: false, navigate, toast }))
        } else if (id) {
          dispatch(editCourseInformation({ courseId: id, ...values, hasId: true, navigate, toast }))
        } else {
          dispatch(createCourseInformation({ ...values, navigate, toast }))
        }
      }}
    >
      {({ values, setFieldValue, handleSubmit, isValid, dirty, errors, touched }) => (
        <div className={`add-info-course-list ${screenSize}`}>
          <div className='filter-bar-wraper-sticky'>
            <div className='add-course-info-course'></div>
            <div className='add-course-info-subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              <div>
                <Button className={'course-info-draft-btn'} disabled={!(isValid && dirty)}>
                  {UI_CONSTANT.SAVE_AS_DRAFT}
                </Button>
                <Button type='submit' className='course-info-next-btn' onClick={handleSubmit}>
                  {id ? UI_CONSTANT.SAVE : UI_CONSTANT.NEXT}
                </Button>
              </div>
            </div>
          </div>
          <Form>
            <div className='add-course-group-parent'>
              <b className='course-information-heading'>{UI_CONSTANT.COURSE.COURSE_INFORMATION}</b>
              <p className='course-info-subHeading'>{UI_CONSTANT.COURSE.FORM_DESCRIPTION}</p>
              <div className='course-divider' />
              <div className='course-form-input-div'>
                <NewInput
                  label='Course Name'
                  name='courseName'
                  placeholder='Enter course name...'
                  width='98'
                  type='text'
                  required={true}
                  onInput={handleInputStringWithNum}
                  maxLength={50}
                />
                <p className='input-character-count'>{UI_CONSTANT.COURSE.CHARACTER_COUNT}</p>
              </div>

              <div className='course-form-input-div'>
                <NewInput
                  label='Alias Name'
                  name='aliasName'
                  placeholder='Enter alias name...'
                  width='98'
                  type='text'
                  required={true}
                  maxLength={50}
                  onInput={handleInputStringWithNum}
                />
              </div>

              <div className='course-form-input-div'>
                <label className='checkbox-title'>Course Exam Type</label>
                <span className='required-symbol checkbox-required'>*</span>
                <div role='group' className='checkbox-wrapper'>
                  <label className='checkbox-div'>
                    <Field type='checkbox' name='checked' value='MCQ' className='course-check-box' />
                    <span className='checkbox-label'>MCQ</span>
                  </label>
                  <label className='checkbox-div'>
                    <Field type='checkbox' name='checked' value='Descriptive' className='course-check-box' />
                    <span className='checkbox-label'>Descriptive</span>
                  </label>
                  <ErrorMessage name='checked' component='div' className='error-course-name' />
                </div>
              </div>
            </div>

            <div className='add-course-group-parent course-section-divider'>
              <div className='course-info-required-wrapper'>
                <label className='course-information-heading'>{UI_CONSTANT.COURSE.ENROLL_MATERIALS}</label>
                <span className='required-symbol materials-required'>*</span>
              </div>

              <p className='course-info-subHeading'>{UI_CONSTANT.COURSE.ENROLL_MATERIALS_DESCRIPTION}</p>
              <Chips
                chipLabels={materials}
                setFieldValue={setFieldValue}
                touched={touched}
                errors={errors}
                idFieldName={'materialId'}
                chipsIdValues={values.materialId}
              />
            </div>
          </Form>
        </div>
      )}
    </Formik>}
    </>
  )
}

export default AddCourseInformation
